import { gql } from '@apollo/client';

export const UPSERT_DASHBOARD_LAYOUT = gql`
  mutation UpsertDashboardLayout($input: UpsertDashboardLayoutInput!) {
    layout: upsertDashboardLayout(input: $input) {
      id
    }
  }
`;
